import { render, staticRenderFns } from "./Prospect.vue?vue&type=template&id=08515b32"
import script from "./Prospect.vue?vue&type=script&lang=js"
export * from "./Prospect.vue?vue&type=script&lang=js"
import style0 from "./Prospect.vue?vue&type=style&index=0&id=08515b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports